module.exports = "/images/aerial-5.jpg";